// eslint-disable-next-line dot-notation
export const env = { ...process.env, ...window['env'] };
